import moment from "moment";
import WasteSelectorTypes from "components/waste-icons/WasteSelectorTypes";
import routesIcons from "./routeIcons";


export class ScheduleRouteModel {
    constructor(route) {
        let current = moment(route.created_at);
        this.id = `route-${route.id}-${route.type}`;
        this.calendarId = WasteSelectorTypes[route.waste_type].calendar.id;
        this.title = route.name;
        this.category = "time";
        this.start = `${current.format("YYYY-MM-DD")}T${route.hour_start || "-"}`;
        this.end = `${current.format("YYYY-MM-DD")}T${route.hour_end || "-"}`;
        this.color = WasteSelectorTypes[route.waste_type].calendar.color;
        this.backgroundColor = WasteSelectorTypes[route.waste_type].backgroundColor;
        this.raw = routesIcons[route.type];
        this.type = route.type;
    }
}

export class ScheduleEventModel {
    constructor(item, route, current) {
        const startTime = `${current.format("YYYY-MM-DD")}T${item.run}`;
        this.id = `${item.id}-${route.item.id}-${route.type}-${Math.floor(new Date(startTime).getTime() / 1000)}`;
        this.calendarId = WasteSelectorTypes[route.item.waste_type].calendar.id;
        this.title = route.name;
        this.category = "time";
        this.start = startTime;
        const endTime = moment(startTime).add(15, 'minutes');
        this.end = endTime.format("YYYY-MM-DDTHH:mm:ss");
        this.color = WasteSelectorTypes[route.item.waste_type].calendar.color;
        this.backgroundColor = WasteSelectorTypes[route.item.waste_type].backgroundColor;
        this.raw = routesIcons[route.type];
        this.progId = item.id;
        this.routeId = route.item.id;
        this.type = route.type;
    }
}